/**
 * OfflineBanner - Shows a banner when the user is offline.
 */

import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineBanner() {
  const { t } = useTranslation();
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      className="fixed top-16 left-0 right-0 z-40 flex items-center justify-center gap-2 bg-amber-500 text-white px-4 py-2 text-sm font-medium shadow-md"
    >
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>{t('offline.banner')}</span>
    </div>
  );
}
